// Existing authenticated read/hydration path, with an explicitly bounded scope.
// An older server ignoring the scope cannot accidentally declare Today complete.
export async function loadTodaySnapshot(service, {signal} = {}) {
  if (signal?.aborted) throw new Error('Activity read canceled');
  const data = await service.fetchActivities(null, 100, null, null, null, null, null, 0, {signal, timeout:15000, todayActionScope:true});
  if (!Array.isArray(data?.activities)) throw new Error('Incomplete activity response');
  return {activities:data.activities, partial:data.scope !== 'today-actions' || data.hasMore !== false};
}
